import { isArray, isEmpty, isNil, reduce } from 'lodash';

const getFilterValue = (value) => {
  if (isArray(value)) {
    return value.join(',');
  }

  return value;
};

const isEmptyFilterValue = (value) => {
  if (isArray(value)) {
    return isEmpty(value);
  }

  return isNil(value);
};

export const buildFilters = (filters) => {
  if (isEmpty(filters)) {
    return {};
  }

  return reduce(
    filters,
    (params, value, key) => {
      if (!isEmptyFilterValue(value)) {
        params[key] = getFilterValue(value);
      }

      return params;
    },
    {}
  );
};
